@if ((vm$ | async); as viewModel) {
  <!-- Loading may occur multiple times, show nothing but the spinner -->
  @if (viewModel.trainingRatingsLoading) {
    <img class="troodi-spinner" src="assets/img/troodi_spinner.gif" />
  }
  <!-- if data is not loading, show user the corresponding view -->
  @if (!viewModel.trainingRatingsLoading) {
    <!-- Show a separator at first -->
    @if (showIntro && !viewModel.currentTrainingRating) {
      <app-slide-separator
        (buttonClicked)="hideIntro()"
        [type]="data?.type"
        [title]="'USER_RATING.INTRO.TITLE' | translate"
        [introText]="'USER_RATING.INTRO.TEXT' | translate"
        [buttonText]="'USER_RATING.INTRO.BUTTON' | translate"
        [skipLink]="nextLink"
        [backLink]="backLink">
      </app-slide-separator>
    }
    <!-- If user submitted feedback for this training, show a separator without action -->
    @if (viewModel.currentTrainingRating) {
      <app-slide-separator
        [type]="data?.type"
        [title]="'USER_RATING.LOCKED.TITLE' | translate"
        [introText]="'USER_RATING.LOCKED.TEXT' | translate"
        [skipLink]="nextLink"
        [skipText]="viewModel.hideCertificateSlide ? undefined : ('USER_RATING.TO_CERTIFICATE' | translate)"
        [backLink]="backLink">
      </app-slide-separator>
    }
    <!-- Otherwise, show the feedback-slide -->
    @if (!showIntro && !viewModel.currentTrainingRating) {
      <div class="card">
        <div class="row justify-content-center">
          <div class="stars col-12 col-md-6 col-xl-4 col-xxl-6 p-2">
            @for (id of numericRatingKeys; track id) {
              <div class="rating">
                <div class="d-flex flex-column">
                  <span class="question" translate>{{'USER_RATING.QUESTIONS.' + id | uppercase}}</span>
                  <div class="rating-buttons py-1 py-xxl-3">
                    <!-- TODO: set iterable in component, maybe? -->
                    @for (r of [1, 2, 3, 4, 5]; track r) {
                      <button mat-icon-button [class.active]="isHighlighted(id, r)" (click)="rate(id, r)">
                        <mat-icon svgIcon="rating_v2"></mat-icon>
                      </button>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="rating col-12 col-md-6 col-xl-6 col-xxl-6 p-2">
            <div class="d-flex flex-column h-100">
              <span class="question" translate>USER_RATING.QUESTIONS.FREETEXT.HEADLINE</span>
              <textarea
                class="mt-1 mt-xxl-3 px-2"
                matInput
                #freeTextRating
                placeholder="{{'USER_RATING.QUESTIONS.FREETEXT.PLACEHOLDER' | translate}}"
              maxlength="5000"></textarea>
              <mat-hint>{{freeTextRating.value.length}} / 5000</mat-hint>
              <button class="col" (click)="sendRating()" mat-raised-button color="primary" [disabled]="!isValid()">
                <span class="text-white" translate>USER_RATING.SEND_FEEDBACK</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- As there is no navbar, we have a similar CTA-Layout as in the separator -->
      <!-- TODO: looking at the current usage of the separators, we might want to rework the slide-concept? -->
      <div class="container cta-container mt-4 mt-xxl-5">
        <div class="row"></div>
        <!-- lower row gets rearranged on smaller devices -->
        <div class="row justify-content-around mt-4">
          @if (backLink) {
            <a class="col-12 order-last order-sm-first col-sm-5" mat-stroked-button [routerLink]="backLink">
              <span translate>INTRO_SLIDE.BACK</span>
            </a>
          }
          @if (nextLink) {
            <a
              class="secondary-cta col-12 order-first order-sm-last mb-2 mb-sm-0 col-sm-5"
              mat-raised-button
              [routerLink]="nextLink">
              <span translate>INTRO_SLIDE.SKIP</span>
            </a>
          }
        </div>
      </div>
    }
  }
}
